import './bootstrap';
import '../css/app.css';

import * as Sentry from "@sentry/browser";

import { createRoot } from 'react-dom/client';
import { createInertiaApp } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { StrictMode } from 'react';

// get env variables
const env = import.meta.env;

const appName = env.VITE_APP_NAME || 'Laravel';

// Initialise Sentry before anything renders so errors thrown during the first
// render are captured. Only enabled for production/staging builds that ship a DSN
// (`import.meta.env.PROD` is false under `npm run dev`), so local development never
// floods the Sentry project. The default integrations capture all uncaught errors
// (window.onerror) and unhandled promise rejections.
const sentryDsn = env.VITE_SENTRY_DSN_PUBLIC;

if (env.PROD && sentryDsn) {
    Sentry.init({
        dsn: sentryDsn,
        environment: env.VITE_SENTRY_ENV || 'production',
        release: env.VITE_SENTRY_RELEASE || undefined,
        maxBreadcrumbs: 50,
        // Errors only by default; raise to enable performance tracing.
        tracesSampleRate: Number(env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? 0),
    });
}

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.jsx`, import.meta.glob('./Pages/**/*.jsx')),
    setup({ el, App, props }) {
        const root = createRoot(el);
        root.render(
            <StrictMode>
                <App {...props} />
            </StrictMode>
        );
    },
    progress: {
        color: '#3b0764',
        showSpinner: true,
    },
});

